
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import config from "@/config";
import { getFormatDate } from "@/common/utils";
import { isCollection, addCollection, deleteCollection } from "@/api/policy";
import Share from "vue-social-share";
import cookie from "js-cookie";
import "vue-social-share/dist/client.css";
import Pdf from "@/components/Pdf";
import { pageViewUnit } from "@/config";
@Component({
  name: "policyDetails",
  components: { Share, Pdf },
})
export default class Publicy extends Vue {
  @Action("policy/getPublicyData") private getPolicyData: any;
  @Action("policy/addPublicyPageView") private addPolicyView: any;
  pageViewUnit = pageViewUnit;
  pageData: any = {};
  publicyId: any = this.$route.query.publicyId;
  file: any = [];
  shareConfig: any = { show: false };
  isCollection: Boolean = false;
  // pdfSrc: string = ''
  pdfSrc: string =
    "https://zst-shop-sh.oss-cn-shanghai.aliyuncs.com/3a38e20151444dc7ade1f1dfb460158e.pdf"; // 'https://fsfczj.foshan.gov.cn/view/static/pdf/web/viewer.html?file=https%3A%2F%2Ffuchifs.oss.zqlian.com%2Fupload%2F2023%2F05%2F18%2Ff5c74bc7071b2e10e2ae67a1ca1c70e8.pdf%3FExpires%3D1688100032%26OSSAccessKeyId%3DLTAI4FopadCFrnCXRnsnCEVU%26Signature%3DCGtEXpTaau%252FSSRJtWx%252BZeHIKaE8%253D';
  mounted() {
    // this.addPolicyView(this.publicyId);
    this.getData();
    console.log(this.$route.query.publicyId, 123);
  }
  download({ url }: any) {
    window.open(url);
  }
  getData() {
    if (cookie.get("accessToken")) {
      isCollection({
        type: "policy",
        id: this.publicyId,
      }).then((res) => {
        this.isCollection = res.data.result;
      });
    }

    this.getPolicyData(this.publicyId).then(({ code, result, msg }: any) => {
      if (code === 200) {
        let data = result;
        const { enclosureVoList } = data;
        data.releaseDate = getFormatDate(data.releaseDate);
        // data.year = data.pubDate.slice(0, 4);
        this.pageData = data;
        const baseURL =
          process.env.NODE_ENV === "development"
            ? config.basicUrl
            : `${location.origin}/`;
        if (enclosureVoList && enclosureVoList.length > 0) {
          this.file = enclosureVoList.map(
            ({ enclosureName, enclosureUrl }: any) => {
              const name = enclosureName.split("-")[
                enclosureName.split("-").length - 1
              ];
              const url = `${baseURL}zst/user/file/downloadFile?filePath=${encodeURIComponent(
                enclosureUrl
              )}`;
              return { name, url };
            }
          );
        }
        this.shareConfig = {
          show: true,
          url:
            config.h5Url + "#/policy/details?id=" + this.$route.query.publicyId,
          source: "黄石政策计算器",
          title: data.title,
          // description: "woshfif",
          sites: ["wechat", "qq", "weibo"],
          wechatQrcodeTitle: "微信扫一扫：分享",
          wechatQrcodeHelper:
            "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
        };
        return data;
      }
    });
  }
  adEvent() {
    if (cookie.get("accessToken")) {
      addCollection({
        type: "policy",
        id: this.publicyId,
      }).then((res) => {
        this.$message.success("收藏成功");
        this.isCollection = true;
      });
    } else {
      this.$message.warning("请先登录!");
    }
  }
  delEvent() {
    deleteCollection({
      type: "policy",
      id: this.publicyId,
    }).then((res) => {
      this.$message("取消收藏");
      this.isCollection = false;
    });
  }
}
